export enum ADAPTIVE_MODE {
    MOBILE = 'mobile',
    DESKTOP = 'desktop',
}

export enum ADAPTIVE_BREAKPOINT {
    W320 = 320,
    W1024 = 1024,
}

export const LS_MANUAL_ADAPTIVE_MODE = 'LS_MANUAL_ADAPTIVE_MODE';
